import { generateId } from '@/services/idService'
import type { Segment, Track } from '@/types/tour'

export function ensureSegmentClientIds(segments: Segment[] | undefined): Segment[] {
  return (segments || []).map((segment) => ({
    ...segment,
    clientId: segment.clientId || generateId(),
  }))
}

export function ensureTrackSegmentClientIds(tracks: Track[] | undefined): Track[] {
  return (tracks || []).map((track) => ({
    ...track,
    segments: ensureSegmentClientIds(track.segments),
  }))
}
